// import Vue from "vue"
import vuex from "vuex"
// import axios from 'axios'
// import API from '../API'
import sizeChart from './modules/applications/sizeChart'
import googleAnalysis from './modules/googleAnalysis'
import settings from "./modules/settings"
import options from './modules/options'
import plugConfig from './modules/plugConfig'
import comments from './modules/comments'
import product from "./modules/product"
import getSymbolFromCurrency from "currency-symbol-map";

Vue.use(vuex)

var country = sessionStorage.getItem("country");
//当localStorage里有选过货币并且汇率里面有这个货币的时候才能选用这个货币，否则都为结账货币
// var pricetype = localStorage.getItem("pricetype") || currentcountry;

// 判断该汇率是否存在，没有则还是默认的结账货币
// pricetype = rates[pricetype] ? pricetype : checkoutcurrency;
var state = {
  ipinfo: null, //ip信息
  checkoutcurrency: null, //结账货币
  currentcountry: null, //用户选择auto时展示的货币
  country,//根据ip获取的国家,地址页使用
  pricetype: null,//用户选择的货币
  priceSymbol: null, // 用户选择的货币符号
  rates: {},//汇率
  rates_base: null, // 汇率基准
  // ratescurrent,
  cartContentsCount: localStorage.getItem("cartContentsCount")||'0',
  order_shipping: '',//邮费仅在shipping页面选择配送方式时使用
  update_cart: false,//更新购物车的开关，仅在payment页面出现优惠券错误时使用
  news_cart: {},//购物车最新信息,使用优惠券时更新
  cart_type: false,//打开抽屉购物车
  discount_not_enough: "",//优惠券出现不满足的时候
  shipping_insurance_price: '',//运费险价格
  new_comment: {},//新添评论
  feature_image_id: null,//venue主题商品详情页切换图片使用
  now_variant: {},//venue主题商品详情页切换变种使用
  disabled: false,//venue加购按钮使用
  checkout_arrive: '',//结账页面跳转目标地址
  special_attrs: {
    //需要特殊处理的字段,目前一个商品仅支持一个属性裂变，多个属性裂变难度倍增
    power: [
      {
        name: "Power( L )", //用来显示,并v-model绑定
      },
      {
        name: "Power( R )",
      }
    ],
  },
  special_attr_key: "power",//特殊处理字段的原始keyname
  special_attr_num: null,//特殊处理字段的长度
  product_tag_list: {},//产品卡片标签数据
  product_palette_list: {},//调色板数据
  custom_button_list: {},//自定义按钮数据
  combination_list: {},//款式组合数据
  variant_list: [],//athena商品详情页有特殊变种时记录下用户选择的变种,供组合商品跟随该变种使用
  theme_name: null,//主题名称
  screenWidth: null, // 屏幕宽度
  screenHeight: null, // 屏幕高度
  scrollMethod:null, //屏幕滚动方式  up 向上滚动  down 向下滚动
  isMobile: false, // 是否移动端
}

var mutations = {
  saveBaseState(state, payload) {
    for (const key in payload) {
      Vue.set(state, key, payload[key])
    }
  },
  change_variant_list(state, variant_list) {
    state.variant_list = variant_list;
  },
  change_new_comment(state, new_comment) {
    state.new_comment = new_comment;
  },
  change_shipping_insurance_price(state, shipping_insurance_price) {
    state.shipping_insurance_price = shipping_insurance_price;
  },
  change_discount_not_enough(state, discount_not_enough) {
    state.discount_not_enough = discount_not_enough;
  },
  change_cart_type(state, cart_type) {
    state.cart_type = cart_type;
  },
  change_news_cart(state, news_cart) {
    state.news_cart = news_cart;
  },
  change_update_cart(state, onOff) {
    state.update_cart = onOff;
  },
  change_order_shipping(state, price) {
    state.order_shipping = price;
  },
  // 保存选择的货币
  changePriceType(state, { payload }) {
    const { currency } = payload;
    const priceSymbol = (currency && getSymbolFromCurrency(currency)) || null;
    state.pricetype = currency
    state.priceSymbol = priceSymbol
  },
  cartContentsCount(state, count) {
    state.cartContentsCount = count
  },
  change_feature_image_id(state, new_id) {
    state.feature_image_id = new_id
  },
  change_now_variant(state, now_variant) {
    state.now_variant = now_variant
  },
  change_button_disabled(state, button_disabled) {
    state.disabled = button_disabled
  },
  change_checkout_arrive(state, checkout_arrive) {
    state.checkout_arrive = checkout_arrive
  },
  change_product_tag_list(state, product_tag_list) {
    state.product_tag_list = { ...state.product_tag_list, ...product_tag_list };
  },
  change_special_attr_info(state, special_attr_info = {}) {
    let { key, num } = special_attr_info;
    state.special_attr_num = num;
  },
  change_special_attr_num(state, special_attr_num) {
    state.special_attr_num = special_attr_num;
  },
  change_product_palette_list(state, product_palette_list) {
    state.product_palette_list = { ...state.product_palette_list, ...product_palette_list };
  },
  change_custom_button_list(state, custom_button_list) {
    state.custom_button_list = { ...state.custom_button_list, ...custom_button_list };
  },

  get_combination_list(state, {combination_list,combination_position}) {
    let list = {};
    if (!combination_list || (combination_list instanceof Array && !combination_list.length)) return;
    if(combination_position) {
      list[combination_position]={}
    }
    combination_list.forEach(item => {
      // list[item.product_id]=item.style_combination;
      if (item.style_combination && item.style_combination.items && item.style_combination.items.length > 1) {
        item.style_combination.items.forEach(i => {
          if(combination_position) {
            list[combination_position][i.product_id] = item.style_combination;
          }
          else {
            list[i.product_id] = item.style_combination;
          }
        })
      }
    });
    state.combination_list = { ...state.combination_list, ...list };
  },

  // 保存汇率信息
  saveReats(state, { payload }) {
    state.rates = payload.rates,
      state.rates_base = payload.rates_base
  },

  // 保存区域的ip, 货币等信息
  saveIpInfo(state, { payload }) {
    state.ipinfo = payload?.ipinfo
    state.country = payload?.country
    state.currentcountry = payload?.currentcountry
    state.checkoutcurrency = payload?.checkoutcurrency

    const { pricetype } = payload || {}
    const priceSymbol = (pricetype && getSymbolFromCurrency(pricetype)) || null;

    state.priceSymbol = priceSymbol
    state.pricetype = pricetype
  },
  // 设置屏幕的宽度
  setScreenWidth(state, { payload }) {
    state.screenWidth = payload.width
    state.screenHeight = payload.height

    // 移动端的界线定位768
    if (payload.width < 768) {
      state.isMobile = true
    } else {
      state.isMobile = false
    }
  },
  // 设置屏幕的宽度
  setScrollMethod(state, { payload }) {
    state.scrollMethod = payload.method
  }
}
var actions = {
  change_new_comment(context, new_comment) {
    context.commit("change_new_comment", new_comment)
  },
  change_shipping_insurance_price(context, shipping_insurance_price) {
    context.commit("change_shipping_insurance_price", shipping_insurance_price)
  },
  change_discount_not_enough(context, discount_not_enough) {
    context.commit("change_discount_not_enough", discount_not_enough)
  },
  change_cart_type(context, cart_type) {
    context.commit("change_cart_type", cart_type)
  },
  change_news_cart(context, news_cart) {
    context.commit("change_news_cart", news_cart)
  },
  change_update_cart(context, onOff) {
    context.commit("change_update_cart", onOff)
  },
  change_order_shipping(context, price) {
    context.commit("change_order_shipping", price)
  },
  // 修改货币类型
  changepricetype({ commit }, currency) {
    commit({
      type: "changePriceType",
      payload: {
        currency,
      }
    })
  },

  cartContentsCount(context, count) {
    context.commit("cartContentsCount", count)
  },
  change_feature_image_id(context, new_id) {
    context.commit("change_feature_image_id", new_id)
  },
  change_now_variant(context, now_variant) {
    context.commit("change_now_variant", now_variant)
  },
  change_button_disabled(context, button_disabled) {
    context.commit("change_button_disabled", button_disabled)
  },
  change_checkout_arrive(context, checkout_arrive) {
    context.commit("change_checkout_arrive", checkout_arrive)
  },
  async change_product_tag_list({ commit }, products_ids) {
    if(!products_ids || (products_ids instanceof Array && !products_ids.length)) return;
    let ids = Array.isArray(products_ids) ? products_ids.join(",") : products_ids;
    let params = {
      "filter[product_id]": ids,
    };
    try {
      let res = await axios.get(API.product_card, { params });
      if (res && res.data) {
        commit("change_product_tag_list", res.data)
      } else {
        commit("change_product_tag_list", {})
      }
    } catch (error) {
      commit("change_product_tag_list", {})
    }
  },
  async get_product_palette({ commit }, products_ids) {
    if(!products_ids || (products_ids instanceof Array && !products_ids.length)) return;
    let ids = Array.isArray(products_ids) ? products_ids.join(",") : products_ids;
    let params = {
      "filter[product_id]": ids,
    };
    try {
      let res = await axios.get(API.palette, { params });
      if (res && res.data) {
        let payload = res.data;

        commit("change_product_palette_list", payload)
      } else {
        commit("change_product_palette_list", {})
      }
    } catch (error) {
      commit("change_product_palette_list", {})
    }
  },
  async get_custom_button({ commit }, products_ids) {
    if(!products_ids || (products_ids instanceof Array && !products_ids.length)) return;
    let ids = Array.isArray(products_ids) ? products_ids.join(",") : products_ids;
    let params = {
      "product_ids": ids,
    };
    try {
      let res = await axios.get(API.custom_button, { params });
      let { data } = res;
      if (data && data.length ) {
        let payload = {};
        data.forEach(item=>{
          payload[item.ID] = item;
        })
        commit("change_custom_button_list", payload)
      } else {
        commit("change_custom_button_list", {})
      }
    } catch (error) {
      commit("change_custom_button_list", {})
    }
  },
  // 获取汇率，当有开启货币选择的时候，需要去请求汇率信息
  async getRates({ commit }, { payload }) {
    const { checkoutCurrency, showCurrenctSelector } = payload
    const sessionRate = sessionStorage.getItem("rates");
    const sessionRatesBase = sessionStorage.getItem("rates_base");

    // 如果保存的数据被篡改， 不合规范，就会造成解析出问题
    try {
      JSON.parse(sessionRate)
    } catch {
      sessionRate = null
    }

    let ratesData = {
      [checkoutCurrency]: 1,
    };

    let ratesBase = checkoutCurrency;

    if (!showCurrenctSelector) {
      ratesData = {
        [checkoutCurrency]: 1,
      },
        ratesBase = checkoutCurrency
    } else {
      if (!sessionRate || checkoutCurrency !== sessionRatesBase) {
        try {
          //获取汇率
          const res = await axios.get(API.exchanges)
          const { rates, base } = res?.data || {}

          // 此处存session的目的是为了刷新页面的时候，不用再次请求该数据
          sessionStorage.setItem("rates", JSON.stringify(rates))
          sessionStorage.setItem("rates_base", base)

          ratesData = rates
          ratesBase = base
        } catch (error) {
          console.error(error);
        }
      } else {
        ratesData = JSON.parse(sessionRate);
        ratesBase = sessionRatesBase;
      }
    }

    commit({
      type: 'saveReats',
      payload: {
        rates: ratesData,
        rates_base: ratesBase,
      }
    })
  },
  // 获取Ip地址信息
  // 开启货币选择的话，需要判断用户上次是选择了货币
  // 如果没有的话，或者选择的是auto的，则要通过ip获取该地区的货币，在计算
  async getIpInfo({ commit }, { payload }) {
    const sessionIpInfo = sessionStorage.getItem("ipinfo"); // ip信息
    let currentcountry = sessionStorage.getItem("currentcountry"); // 根据ip得出货币
    let pricetype = localStorage.getItem('pricetype'); // 用户选择的货币
    let country = sessionStorage.getItem("country"); // ip 所在的国家或地区
    let ipinfo = null

    const { rates } = state; // 获取汇率数据
    const { checkoutCurrency, showCurrenctSelector ,checkoutAutoComplete } = payload

    // 可能解析失败
    try {
      ipinfo = JSON.parse(sessionIpInfo)
    } catch (e) {
      ipinfo = null
    }

    // 如果用户选择的没有相关汇率
    if (rates && pricetype && !rates[pricetype]) {
      pricetype = null
    }

    // 没有开启货币选择
    if (!showCurrenctSelector  && checkoutAutoComplete !== 'yes') {
      pricetype = checkoutCurrency
      sessionStorage.removeItem('ipinfo');
      sessionStorage.removeItem('country');
      sessionStorage.removeItem('currentcountry');
      // sessionStorage.removeItem('pricetype')
    } else {
      // 如果本地暂存的数据为空,则再次去请求
      if (!ipinfo || !currentcountry || !country) {
        try {
          const res = await axios.get(API.ipinfo);
          ipinfo = res?.data || {}
        } catch (error) {
          console.error(error)
        }
      }

      // ip地址的货币
      const currency = ipinfo?.currency || currentcountry; // 货币
      currentcountry = state?.rates?.[currency] ? currency : checkoutCurrency;
      country = ipinfo?.iso_code || null;
      pricetype = pricetype || currentcountry;

      sessionStorage.setItem("ipinfo", JSON.stringify(ipinfo));
      sessionStorage.setItem("country", country || null);
      sessionStorage.setItem("currentcountry", currentcountry);
    }
    commit({
      type: 'saveIpInfo',
      payload: {
        ipinfo, // ip信息
        country, // 当前国家
        pricetype: pricetype || checkoutCurrency, // 用户选择的换算货币
        checkoutcurrency: checkoutCurrency, // 后台设置的结账货币
        currentcountry // 当前区域支持的货币
      }
    })
  },
  async get_combination_list({ commit }, payload) {
    let params = {
      ...payload
    };
    try {
      let res = await axios.get(API.style_combination, { params });
      if (res && res.data && res.data.data) {
        commit("get_combination_list", {combination_list:res.data.data,combination_position:payload.combination_position})
      } else {
        commit("get_combination_list", {})
      }
    } catch (error) {
      commit("get_combination_list", {})
    }
  },
}
const store = new vuex.Store({
  state,
  mutations,
  actions,
  modules: {
    sizeChart,
    googleAnalysis,
    options,
    plugConfig,
    comments,
    settings,
    product
  }
})

export default store
